var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { z } from 'zod';
var PendingOverrideDataSchema = z.object({
    Id: z.string().uuid(),
    SharingTargets: z.array(z.string()),
    IsInternalShare: z.boolean(),
    UserMail: z.string(),
    ObjectUrl: z.string().url(),
    ObjectName: z.string(),
    ObjectType: z.number(),
    CustomerId: z.string().uuid(),
    Timestamp: z.string().refine(function (val) { return !isNaN(Date.parse(val)); }, {
        message: "Invalid date format",
    }),
});
var safeDeserialize = function (content, schema) {
    var result = z
        .string()
        .transform(function (_, ctx) {
        try {
            return JSON.parse(content);
        }
        catch (error) {
            console.log(error);
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'invalid json',
            });
            return z.never;
        }
    })
        .pipe(schema)
        .safeParse(content);
    if (!result.success) {
        return;
    }
    return result.data;
};
export var deserializeToken = function (token) {
    if (!token) {
        return;
    }
    try {
        var jsonString = atob(token);
        var result = safeDeserialize(jsonString, PendingOverrideDataSchema);
        if (!result) {
            return;
        }
        return __assign(__assign({}, result), { Timestamp: new Date(result.Timestamp) });
    }
    catch (error) {
        return;
    }
};
